import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "BankOfCD",
  "use": "BankOfCD-usage",
  "viewBox": "0 0 69.001 69",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 69.001 69\" id=\"BankOfCD\">\r\n  <defs>\r\n    <style>\r\n      #BankOfCD .cls-1 {\r\n        fill: #e50012;\r\n      }\r\n\r\n      #BankOfCD .cls-1, #BankOfCD .cls-2 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      #BankOfCD .cls-2 {\r\n        fill: #f29600;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"BankOfCD_形状_1179\" data-name=\"形状 1179\" class=\"cls-1\" d=\"M4037.27,1023.2l-27.16,26.92s-6.74,8.25-14.78.65l34.55-34.51Zm-16.08,52.75,26.94-27.13s8.26-6.73.65-14.76l-34.98,34.51Z\" transform=\"translate(-3986.69 -1006.94)\" />\r\n  <path id=\"BankOfCD_形状_1179_拷贝_3\" data-name=\"形状 1179 拷贝 3\" class=\"cls-2\" d=\"M4021.19,1006.92l-26.94,27.14s-8.26,6.73-.65,14.76l34.54-34.52Zm-16.3,52.75,27.16-26.91s6.74-8.25,14.78-.66l-34.98,34.52Z\" transform=\"translate(-3986.69 -1006.94)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/BankOfCD.svg
// module id = T72f
// module chunks = 37